module.exports = __webpack_public_path__ + "img/l4-light.fcf7c3a3.png";